// On page requested as hashtag
import {isValidSelector} from "../utils/utils";

$(window).on('load', function () {
    let hash = "";
    if (hash = window.location.hash) {
        if (isValidSelector(hash)) {
            if ($(hash).length) {
                let height = $(hash).offset().top - getOffset();
                $("html, body").stop().animate({scrollTop: height}, 400);
            }
        }
    }
});

//Click on # href link
$(document).on('click', 'a', function (e) {
    var url = $(this).attr('href');
    if (url !== "#" && url !== undefined) {
        if (url.indexOf("#") > -1) {
            var ancre = url.substring(url.indexOf("#"));
            if ($(ancre).length) {
                var height = $(ancre).offset().top - getOffset();
                $('html, body').stop().animate({scrollTop: height}, 400);
            }
        }

    }
});

//Get height of header
function getOffset() {
    if ($(window).width() >= 768) {
        return 10;
    } else {
        return 75;
    }
}
